const root = `td-register/penalize/`
const urls = {
  getDetail: root + 'detail',
  getList: root + 'page',
  remove: root + 'remove',
  add: root + 'save',
  detail: root + 'detail',
  update: root + 'update',
  correctCaseArea: root + 'correctCaseArea'
}

// 获取列表页数据
export const getList = obj => {
  return $http.get(urls.getList, obj)
}
// 删除列表中目标数据
export const remove = obj => {
  let ids = Array.isArray(obj) ? obj.map(z => z.id).join(',') : obj.id
  return $http.post(`${urls.remove}?ids=${ids}`)
}

export const add = obj => {
  return $http.post(urls.add, obj)
}
export const detail = id => {
  return $http.get(urls.detail, { id: id })
}
export const update = obj => {
  if (obj.registYear) {
    obj.registYear = obj.registYear.substring(0, 4)
  }
  return $http.post(urls.update, obj)
}
/**
 * 修正案件
 * @param {*} obj
 * @returns
 */
export const correctCaseArea = obj => {
  return $http.post(urls.correctCaseArea, obj, {
    headers: { 'Content-Type': 'application/x-www-form-urlencoded' }
  })
}
export default {
  add,
  update,
  detail,
  getList,
  remove,
  correctCaseArea
}
